import { Button, Modal, Popconfirm, Space } from "antd"
import { HelpCircle, Pencil, Trash2 } from "lucide-react"
import { User } from "@types"
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { UsersForm } from "./UsersForm";
import { useDeleteUser } from "@hooks";

interface Props {
    user: User;
}

export const UsersTableActions = ({user}: Props) => {

    const {t} = useTranslation();
    const deleteUser = useDeleteUser();
    const [isModalOpen, setIsModalOpen] = useState(false);  
  
    return (
      <div>
        <Space>
          <Button icon={<Pencil />} onClick={() => setIsModalOpen(true)} />
          <Popconfirm
            title={t("forms.user.deleteUser")}
            description={t("forms.user.deleteDesc")}
            onConfirm={() => deleteUser.mutate(user.id)}
            okButtonProps={{ loading: deleteUser.isPending }}
            icon={<HelpCircle style={{ color: "red", marginRight: 8 }} />}
          >
            <Button icon={<Trash2 />} danger />
          </Popconfirm>
        </Space>

        <Modal
          title={t("forms.user.editUser")}
          open={isModalOpen}
          destroyOnClose
          footer={null}
          onCancel={() => setIsModalOpen(false)}
        >
          <UsersForm user={user} setIsModalOpen={setIsModalOpen} />
        </Modal>
      </div>
    );
}